// Vue
import Vue from 'vue'
import Vuex from 'vuex'
import pathify from '@/plugins/vuex-pathify'

// Modules
import * as modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,
  modules,
  plugins: [pathify.plugin],
})

export default store

export const ROOT_DISPATCH = Object.freeze({ root: true })
